// This component handles the App template used on every page.
/*eslint-disable react/no-set-state*/
import React, {PropTypes} from 'react';
import {bindActionCreators} from 'redux';
import Header from './common/Header';
import SessionTimer from './common/SessionTimer';
import Footer from './common/Footer';
import {connect} from 'react-redux';
import {browserHistory} from 'react-router';
import '../styles/common/app.css';
import SessionModal from './common/SessionModal';
import LoadingCircle from './common/LoadingCircle';
import SessionStorageService from '../services/sessionStorage/sessionStorageService';
import * as loginActions from '../actions/loginActions';
import * as accountActions from '../actions/accountActions';
import * as pathConstants from '../constants/pathConstants';
import * as formNames from '../constants/formNameConstants';
import Errors from './common/Errors';

class App extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      showExtendModal: false,
      setTimer: '',
    };
    let currentTime = +new Date();
    let storedTime = SessionStorageService.getItem('lastLogin');

    let timeDiff = (currentTime - storedTime) / 3600 / 1000;

    // if user has a running session on page refresh/navigation,
    // reload user/login/establishment state and redirect
    if (this.props.session && storedTime !== null &&
      this.props.session.username && timeDiff < 4) {
        let newCredentials = {
          email: this.props.session.username,
          password: this.props.session.password
        };
        let path = this.props.path;
        if (path === '/' ||
          path === pathConstants.pathToLogin ||
          path.slice(0, -1) === pathConstants.pathToLogin) {
          //if user is logged in but attempts to navigate to login page,
          //send to home page instead
          path = pathConstants.pathToHome;
        }
        this.props.accountActions.getAllEstablishments(this.props.session);
        this.props.loginActions.login(newCredentials)
          .then((response) => {
            if (response.authenticated) {
              browserHistory.push(path);
            }
          });
    }
    else if (timeDiff >= 4) {
      clearInterval(this.state.setTimer);
      SessionStorageService.deleteItem('lastLogin');
    }

    this.logout = this.logout.bind(this);
    this.extendSession = this.extendSession.bind(this);
    this.onNavChange = this.onNavChange.bind(this);
  }

  componentWillReceiveProps() {
    if (SessionStorageService.getItem('lastLogin') &&
      this.state.setTimer === '') {
        let setTimer = setInterval(() => {
        let currentTime = +new Date();
        let storedTime = SessionStorageService.getItem('lastLogin');
        let timeDiff = (currentTime - storedTime) / 3600 / 1000;

        if (storedTime !== null && timeDiff > 3.75 &&
          this.state.showExtendModal === false) {
            this.setState({showExtendModal: true});
        }
        else if (storedTime !== null && timeDiff > 4) {
          this.setState({showExtendModal: false});
          this.logout();
        }
      }, 60000);
      this.setState({setTimer: setTimer});
    }
  }

  onNavChange(eventKey) {
    browserHistory.push(eventKey);
  }

  extendSession(event) {
    event.preventDefault();
    this.setState({showExtendModal: false});
    let currentTime = +new Date();
    SessionStorageService.saveItem('lastLogin', currentTime);
  }

  logout() {
    clearInterval(this.state.setTimer);
    sessionStorage.setItem('helpRedirect', '0');
    this.props.loginActions.logout(this.props.user);
    // browserHistory.push(pathConstants.pathToLogin);
  }

  render() {
    let loadingClass = this.props.loading ? "loading-transparent" : "";
    console.log('Running build: ' + '<REACT_BUILD_ID>');
    return (
      <div>
        <SessionTimer
          authenticated={this.props.authenticated}/>
        <LoadingCircle loading={this.props.loading}/>
        <div className={loadingClass}>
          <Header
            authenticated={this.props.authenticated}
            user={this.props.user}
            logout={this.logout}
            onNavChange={this.onNavChange}
            menuTitleShown={this.props.showMenuTitle}
            pageName={this.props.pageName}
            showMenu={this.props.showPageMenu}
            parent={this.props.parent}
          />
          <SessionModal
            showExtendModal={this.state.showExtendModal}
            extendSession={this.extendSession}
            message="Your session has been active for 3 hours and 45 minutes and is about to expire. Your session will end in 15 minutes and you will be redirected to the Login page.   If your session ends, any unsaved data will be lost.  If you would like to continue your current session please click OK."
          />
          <Errors errors={this.props.errors}/>
          {this.props.children}
          <Footer/>
        </div>
      </div>
    );
  }
}

App.propTypes = {
  children: PropTypes.object.isRequired,
  loginActions: PropTypes.object.isRequired,
  accountActions: PropTypes.object.isRequired,
  pageName: PropTypes.string,
  authenticated: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  showPageMenu: PropTypes.bool.isRequired,
  showMenuTitle: PropTypes.bool.isRequired,
  session: PropTypes.object.isRequired,
  path: PropTypes.string.isRequired,
  parent: PropTypes.object.isRequired,
  user: PropTypes.object,
  errors: PropTypes.array.isRequired,
  preview: PropTypes.bool.isRequired
};

function getPageInfo(path, returnBoth) {
  let pageName, parent = {};
  if (path && path === pathConstants.pathToHome) {
    //path is home page
    pageName = formNames.itaHomePage;
  }
  else if (path && path === pathConstants.pathToHelpRequest) {
    //help request
    pageName = formNames.helpRequestPage;
    if (returnBoth) {
      parent.link = pathConstants.pathToHome;
      parent.name = getPageInfo(parent.link, false).pageName;
    }
  }
  else if (path && path === pathConstants.pathToHelpRequestConfirm) {
    //help request confirmation
    pageName = formNames.helpRequestPageConfirmation;
    if (returnBoth) {
      sessionStorage.setItem('onLogin', '3');
      parent.link = pathConstants.pathToHome;
      parent.name = getPageInfo(parent.link, false).pageName;
    }
  }
  else if (path && path === pathConstants.pathToEstablishmentsDashboardPage) {
    //estab dashboard
    pageName = formNames.itaDashboardPage;
    if (returnBoth) {
      parent.link = pathConstants.pathToHome;
      parent.name = getPageInfo(parent.link, false).pageName;
    }
  }
  else if (path && path === pathConstants.pathToCreateEstablishmentPage) {
    //create estab
    pageName = formNames.itaCreateEstablishment;
    if (returnBoth) {
      parent.link = pathConstants.pathToEstablishmentsDashboardPage;
      parent.name = getPageInfo(parent.link, false).pageName;
    }
  }
  else if (path && path === pathConstants.pathToBulkTransferPage) {
    //bulk transfer
    pageName = formNames.bulkTransferPage;
    if (returnBoth) {
      parent.link = pathConstants.pathToHome;
      parent.name = getPageInfo(parent.link, false).pageName;
    }
  }
  else if (path
    && path.split('/').slice(0, -1).join('/') == pathConstants.pathToEstablishmentsDashboardPage) {
    //view estab
    pageName = formNames.establishmentViewPage;
    if (returnBoth) {
      parent.link = pathConstants.pathToEstablishmentsDashboardPage;
      parent.name = getPageInfo(parent.link, false).pageName;
    }
  }
  else if (path && (path.split('/').slice(-1) == pathConstants.pathToEditEstablishmentPage.slice(1))
    && path.indexOf('establishments') !== -1) {
    //edit estab page
    let id = path.split('/').slice(-2, -1);
    pageName = formNames.itaEditEstablishment;
    if (returnBoth) {
      parent.link = `${pathConstants.pathToEstablishmentsDashboardPage}/` + id;
      parent.name = getPageInfo(parent.link, false).pageName;
    }
  }
  else if (path && path.substring(0, path.indexOf(pathConstants.accountPageBase) != -1)) {
    //account manage pages
    pageName = formNames.itaAccountPage;
    if (returnBoth) {
      parent.link = pathConstants.pathToHome;
      parent.name = getPageInfo(parent.link, false).pageName;
    }
  }
  else if (path && path === pathConstants.pathToFileUploadForm) {
    //file upload
    pageName = formNames.itaFileUpload;
    if (returnBoth) {
      parent.link = pathConstants.pathToHome;
      parent.name = getPageInfo(parent.link, false).pageName;
    }
  }
  else if (path && path === pathConstants.pathToCaseDataFileUploadForm) {
    //case data file upload
    pageName = formNames.itaCaseDataFileUpload;
    if (returnBoth) {
      parent.link = pathConstants.pathToHome;
      parent.name = getPageInfo(parent.link, false).pageName;
    }
  }
  else if (path && path.split('/').slice(-1) == pathConstants.pathToInjurySummaryFormPageAdd.slice(1)) {
    //add 300A
    let id = path.split('/').slice(-2, -1);
    pageName = formNames.itaInjurySummaryFormNameAdd;
    if (returnBoth) {
      parent.link = `${pathConstants.pathToEstablishmentsDashboardPage}/` + id;
      parent.name = getPageInfo(parent.link, false).pageName;
    }
  }
  else if (path && path.split('/').slice(-2, -1) == pathConstants.pathToInjurySummaryFormPageEdit.slice(1)) {
    //edits 300A
    let id = path.split('/').slice(-3, -2);
    pageName = formNames.itaInjurySummaryFormNameEdit;
    if (returnBoth) {
      parent.link = `${pathConstants.pathToEstablishmentsDashboardPage}/` + id;
      parent.name = getPageInfo(parent.link, false).pageName;
    }
  }
  else if (path && path.indexOf(pathConstants.pathToSubmissionPage) != -1) {
    //submission view page
    let id = path.split('/').slice(-3, -2);
    pageName = formNames.submissionViewPage;
    if (returnBoth) {
      parent.link = `${pathConstants.pathToEstablishmentsDashboardPage}/` + id;
      parent.name = getPageInfo(parent.link, false).pageName;
    }
  }
  else if (path && path === pathConstants.pathToLogin
    || path === pathConstants.pathToLoginWithPasswordReset
    || path === pathConstants.pathToLogin + "/"
    || path === "/") {
    //login page name
    pageName = formNames.itaLoginPage;
    if (returnBoth) {
      parent.link = pathConstants.pathToInjuryReporting;
      parent.name = formNames.injuryReportingPage;
    }
  }
  else if (path && path === pathConstants.pathToCreateAccount) {
    //create account page
    pageName = formNames.itaCreateAccount;
    if (returnBoth) {
      parent.link = pathConstants.pathToLogin;
      parent.name = getPageInfo(parent.link, false).pageName;
    }
  }
  else if (path && path === pathConstants.pathToForgotPassword) {
    //forgot password page
    pageName = formNames.forgotPassword;
    if (returnBoth) {
      parent.link = pathConstants.pathToLogin;
      parent.name = getPageInfo(parent.link, false).pageName;
    }
  }
  // /injuryreporting/ita/establishments/1059661/add-case-data => /add-case-data
  // Slice on a string returns string from that char. String comparison with array
  // forces a toString comparison with contents.
  else if (path && path.split('/').slice(-1) == pathConstants.pathToCaseDataFormPageAdd.slice(1)) {
    //add Case Data
    let id = path.split('/').slice(-2, -1);
    pageName = formNames.caseDataFormNameAdd;
    if (returnBoth) {
      parent.link = `${pathConstants.pathToEstablishmentsDashboardPage}/` + id + `${pathConstants.pathToCaseDataDashboardPage}`;
      parent.name = getPageInfo(parent.link, false).pageName;
    }
  }
  // injuryreporting/ita/establishments/1059661/edit-case-data/16 => /edit-case-data
  else if (path && path.split('/').slice(-2, -1) == pathConstants.pathToCaseDataFormPageEdit.slice(1)) {
    //edit Case Data
    let id = path.split('/').slice(-3, -2);
    pageName = formNames.caseDataFormNameEdit;
    if (returnBoth) {
      parent.link = `${pathConstants.pathToEstablishmentsDashboardPage}/` + id + `${pathConstants.pathToCaseDataDashboardPage}`;
      parent.name = getPageInfo(parent.link, false).pageName;
    }
  }
  // injuryreporting/ita/establishments/1059661/case-data => /case-data
  else if (path && path.split('/').slice(-1) == pathConstants.pathToCaseDataDashboardPage.slice(1)) {
    //Case Data Dashboard
    let id = path.split('/').slice(-2, -1);
    pageName = formNames.caseDataDashboard;
    if (returnBoth) {
      parent.link = `${pathConstants.pathToEstablishmentsDashboardPage}/` + id;
      parent.name = getPageInfo(parent.link, false).pageName;
    }
  }
  else {
    pageName = "";
  }
  if (returnBoth) {
    return {pageName, parent};
  } else {
    return {pageName};
  }
}

function showMenu(pageName) {
  return pageName === formNames.itaHomePage;
}

function menuTitleShown(pageName) {
  return pageName === formNames.itaLoginPage;
}

function mapStateToProps(state, ownProps) {

  let authenticated = false;
  let loading = false;
  let session = JSON.parse(SessionStorageService.getItem('credentials')) || {};
  let path = ownProps.location.pathname;
  let user = state.user[state.user.length - 1];
  let {pageName, parent} = getPageInfo(path, true);
  let showPageMenu = showMenu(pageName);
  let showMenuTitle = menuTitleShown(pageName);

  if (state.login.length > 0) {
    authenticated = state.login[state.login.length - 1].authenticated;
  }

  if (!authenticated && path === pathConstants.pathToHelpRequest) {
    //if not logged in accessing help page
    parent.link = pathConstants.pathToLogin;
    parent.name = getPageInfo(parent.link, false).pageName;
  }
  if (!authenticated && path === pathConstants.pathToHelpRequestConfirm) {
    //if not logged in accessing help page
    parent.link = pathConstants.pathToLogin;
    parent.name = getPageInfo(parent.link, false).pageName;
  }
  if (state.ajaxCallsInProgress > 0) {
    loading = true;
  }

  let preview = window.location.host === "preview.osha.gov"
    || window.location.host === "drupal-preview.osha.gov"
    || window.location.host === "drupal-edit.preview.osha.gov";

  return {
    authenticated,
    loading,
    session,
    showPageMenu,
    showMenuTitle,
    path,
    parent,
    pageName,
    user,
    preview,
    errors: state.errors
  };
}

function mapDispatchToProps(dispatch) {
  return {
    loginActions: bindActionCreators(loginActions, dispatch),
    accountActions: bindActionCreators(accountActions, dispatch)
  };
}


export default connect(mapStateToProps, mapDispatchToProps)(App);



/** WEBPACK FOOTER **
 ** ./src/components/App.js
 **/